<template>
  <div class="card-dash">
    <div class="drag-btn">
      <svg
        width="13"
        height="18"
        viewBox="0 0 13 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 18L0 15.4286H2.6V18H0ZM5.2 18V15.4286H7.8V18H5.2ZM10.4 18V15.4286H13V18H10.4ZM0 12.8571L0 10.2857H2.6V12.8571H0ZM5.2 12.8571V10.2857H7.8V12.8571H5.2ZM10.4 12.8571V10.2857H13V12.8571H10.4ZM0 7.71429L0 5.14286H2.6V7.71429H0ZM5.2 7.71429V5.14286H7.8V7.71429H5.2ZM10.4 7.71429V5.14286H13V7.71429H10.4ZM0 2.57143L0 0L2.6 0V2.57143H0ZM5.2 2.57143V0L7.8 0V2.57143H5.2ZM10.4 2.57143V0L13 0V2.57143H10.4Z"
          fill="#B3C2CB"
        />
      </svg>
      <!-- <img :src="img" alt="image" class="ico__img" /> -->
    </div>
    <div class="ico ico__menu">
      <svg
        @click="showScreen()"
        width="14"
        height="14"
        viewBox="0 0 11 11"
        fill="none"
        style="margin:4px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 5.31034V9.86207C11 10.1639 10.8801 10.4533 10.6667 10.6667C10.4533 10.8801 10.1639 11 9.86207 11H1.13793C0.836133 11 0.546696 10.8801 0.333292 10.6667C0.119889 10.4533 0 10.1639 0 9.86207L0 1.13793C0 0.836133 0.119889 0.546696 0.333292 0.333292C0.546696 0.119889 0.836133 0 1.13793 0L5.68966 0C5.84055 0 5.98527 0.0599444 6.09197 0.166646C6.19868 0.273348 6.25862 0.418066 6.25862 0.568965C6.25862 0.719865 6.19868 0.864583 6.09197 0.971285C5.98527 1.07799 5.84055 1.13793 5.68966 1.13793H1.51724C1.41673 1.13823 1.32043 1.17829 1.24936 1.24936C1.17829 1.32043 1.13823 1.41673 1.13793 1.51724V9.48276C1.13823 9.58327 1.17829 9.67957 1.24936 9.75064C1.32043 9.82171 1.41673 9.86177 1.51724 9.86207H9.48276C9.58327 9.86177 9.67957 9.82171 9.75064 9.75064C9.82171 9.67957 9.86177 9.58327 9.86207 9.48276V5.31034C9.86207 5.15945 9.92201 5.01473 10.0287 4.90803C10.1354 4.80132 10.2801 4.74138 10.431 4.74138C10.5819 4.74138 10.7267 4.80132 10.8334 4.90803C10.9401 5.01473 11 5.15945 11 5.31034Z"
          fill="#5B5B5B"
        />
        <path
          d="M11 0.379311V3.03449C11 3.18538 10.9401 3.3301 10.8334 3.43681C10.7267 3.54351 10.582 3.60345 10.4311 3.60345C10.2802 3.60345 10.1355 3.54351 10.0288 3.43681C9.92205 3.3301 9.86211 3.18538 9.86211 3.03449V1.94207L6.44073 5.36345C6.33287 5.46396 6.19022 5.51867 6.04282 5.51607C5.89541 5.51347 5.75478 5.45376 5.65053 5.34951C5.54629 5.24527 5.48658 5.10463 5.48398 4.95723C5.48137 4.80983 5.53609 4.66717 5.63659 4.55932L9.05797 1.13793H7.96556C7.81466 1.13793 7.66994 1.07799 7.56324 0.971286C7.45654 0.864584 7.39659 0.719865 7.39659 0.568966C7.39659 0.418067 7.45654 0.273348 7.56324 0.166646C7.66994 0.0599445 7.81466 0 7.96556 0L10.6207 0C10.7212 0.000300173 10.8175 0.0403596 10.8886 0.111429C10.9597 0.182499 10.9997 0.278804 11 0.379311Z"
          fill="#5B5B5B"
        />
      </svg>
      <svg
        width="16"
        height="16"
        @click="share = !share"
        viewBox="0 0 10 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.16145 6.50978L2.91388 6.36278L2.70794 6.56399C2.45583 6.81029 2.12537 6.95833 1.76471 6.95833C1.01223 6.95833 0.375 6.31728 0.375 5.5C0.375 4.68284 1.01204 4.04186 1.76437 4.04167C2.11252 4.04233 2.44993 4.18139 2.70659 4.43468L2.91256 4.63796L3.16141 4.49025L6.68553 2.39841L6.89833 2.2721L6.86588 2.02677C6.86378 2.01092 6.86182 1.99641 6.86001 1.98301C6.85092 1.91575 6.84559 1.8763 6.84559 1.83333C6.84559 1.01605 7.48282 0.375 8.23529 0.375C8.98777 0.375 9.625 1.01605 9.625 1.83333C9.625 2.65062 8.98777 3.29167 8.23529 3.29167C7.87463 3.29167 7.54417 3.14363 7.29206 2.89732L7.08614 2.69614L6.83859 2.84309L3.31447 4.93492L3.10167 5.06123L3.13412 5.30656C3.13622 5.32241 3.13818 5.33692 3.13999 5.35032C3.14908 5.41758 3.15441 5.45703 3.15441 5.5C3.15441 5.54297 3.14908 5.58242 3.13999 5.64968C3.13818 5.66308 3.13622 5.67759 3.13412 5.69344L3.10167 5.93877L3.31447 6.06508L6.83859 8.15691L7.08614 8.30386L7.29206 8.10268C7.54417 7.85637 7.87463 7.70833 8.23529 7.70833C8.98777 7.70833 9.625 8.34938 9.625 9.16667C9.625 9.98395 8.98777 10.625 8.23529 10.625C7.48282 10.625 6.84559 9.98395 6.84559 9.16667C6.84559 9.12344 6.85101 9.08354 6.86022 9.01575C6.86196 9.00296 6.86383 8.98919 6.86583 8.97421L6.89855 8.72868L6.68557 8.60222L3.16145 6.50978Z"
          stroke="#5B5B5B"
          stroke-width="0.75"
        />
      </svg>
      <svg
        @click="menu = !menu"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
          fill="#B3C2CB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5Z"
          fill="#B3C2CB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19Z"
          fill="#B3C2CB"
        />
      </svg>
    </div>

    <div class="overlay" v-if="menu || share" @click="unset()"></div>
    <div
      class="tool-overlay"
      :class="{ 'tool-overlay-active': fullscreen === true }"
      @click="showScreen()"
    ></div>
    <div class="menu" v-if="menu">
      <p
        :class="{ active: active == 'spotlight' }"
        @click="active = 'spotlight'"
      >
        Spotlight
      </p>
      <p :class="{ active: active == 'setting' }" @click="active = 'setting'">
        Setting
      </p>
      <p :class="{ active: active == 'splash' }" @click="active = 'splash'">
        Splash
      </p>
      <hr />
      <p class="danger" @click="showConfirm()">Remove</p>
    </div>
    <div class="share" v-if="share">
      <div class="social_ico">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.0066 18.0001C17.5551 18.0001 18 17.5553 18 17.0066V0.993445C18 0.444726 17.5551 0 17.0066 0L0.993445 0C0.444656 0 0 0.444726 0 0.993445L0 17.0066C0 17.5553 0.444656 18.0001 0.993445 18.0001H17.0066Z"
            fill="#395185"
          />
          <path
            d="M12.4196 18.0001V11.0295H14.7594L15.1097 8.31297H12.4196V6.5785C12.4196 5.79199 12.6381 5.25599 13.766 5.25599L15.2045 5.25536V2.82571C14.9556 2.7926 14.1017 2.71863 13.1084 2.71863C11.0343 2.71863 9.61438 3.9846 9.61438 6.30956V8.31297H7.26862V11.0295H9.61438V18.0001H12.4196Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="social_ico">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.3359 15.3365H12.6688V11.1597C12.6688 10.1637 12.6511 8.88156 11.2817 8.88156C9.89263 8.88156 9.68007 9.96676 9.68007 11.0872V15.3362H7.01312V6.74708H9.57341V7.92088H9.60927C9.86549 7.48277 10.2357 7.12235 10.6806 6.87802C11.1255 6.63368 11.6283 6.51459 12.1355 6.5334C14.8386 6.5334 15.337 8.31147 15.337 10.6246L15.3359 15.3365ZM4.00374 5.57308C3.14895 5.57322 2.45588 4.88036 2.45574 4.02557C2.4556 3.17078 3.14839 2.47771 4.00318 2.47757C4.85797 2.47736 5.55104 3.17022 5.55118 4.02501C5.55125 4.43549 5.38827 4.8292 5.09807 5.11952C4.80787 5.40983 4.41423 5.57298 4.00374 5.57308ZM5.33729 15.3365H2.66745V6.74708H5.33722V15.3365L5.33729 15.3365ZM16.6655 0.000669186H1.3273C0.602375 -0.00748706 0.00788281 0.573224 -0.000976562 1.29815V16.7003C0.00760156 17.4256 0.602023 18.0069 1.32723 17.9993H16.6655C17.3922 18.0083 17.989 17.427 17.999 16.7003V1.29695C17.9887 0.570622 17.3919 -0.0100183 16.6655 -0.000526127"
            fill="#0A66C2"
          />
        </svg>
      </div>
      <div class="social_ico">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.28 0L0.72 0C0.32175 0 0 0.32175 0 0.72L0 17.28C0 17.6783 0.32175 18 0.72 18H17.28C17.6783 18 18 17.6783 18 17.28V0.72C18 0.32175 17.6783 0 17.28 0ZM13.8443 6.51825C13.851 6.624 13.851 6.73425 13.851 6.84225C13.851 10.1453 11.3355 13.95 6.73875 13.95C5.32125 13.95 4.00725 13.5383 2.90025 12.8295C3.10275 12.852 3.29625 12.861 3.50325 12.861C4.67325 12.861 5.74875 12.465 6.606 11.7945C5.508 11.772 4.5855 11.052 4.2705 10.062C4.65525 10.1183 5.00175 10.1183 5.39775 10.017C4.83238 9.90214 4.32422 9.59509 3.95959 9.14801C3.59495 8.70094 3.39635 8.14142 3.3975 7.5645V7.533C3.72825 7.71975 4.1175 7.8345 4.52475 7.85025C4.1824 7.62209 3.90163 7.31297 3.70735 6.95032C3.51307 6.58766 3.41128 6.18267 3.411 5.77125C3.411 5.3055 3.5325 4.88025 3.75075 4.51125C4.37828 5.28376 5.16134 5.91557 6.04905 6.36562C6.93675 6.81568 7.90922 7.0739 8.90325 7.1235C8.55 5.42475 9.819 4.05 11.3445 4.05C12.0645 4.05 12.7125 4.3515 13.1693 4.8375C13.734 4.73175 14.274 4.52025 14.7555 4.23675C14.5688 4.815 14.1773 5.30325 13.6575 5.6115C14.1615 5.5575 14.6475 5.418 15.0975 5.22225C14.7578 5.72175 14.3325 6.165 13.8443 6.51825Z"
            fill="#00ACEE"
          />
        </svg>
      </div>
    </div>
    <h2 class="title" v-if="active != 'splash'">
      <!-- <img :src="img" alt="image" class="ico__img" /> -->
      {{ title }}
    </h2>

    <div class="settings" v-if="active == 'setting'">
      <div class="tabs__settings">
        <span
          @click="settings.active = 'settings'"
          :class="{ active: settings.active == 'settings' }"
        >
          Setting
        </span>
        <span
          @click="settings.active = 'set-up'"
          :class="{ active: settings.active == 'set-up' }"
        >
          Set-up
        </span>
        <span
          @click="settings.active = 'connect'"
          :class="{ active: settings.active == 'connect' }"
        >
          Connect
        </span>
      </div>
      <div class="body__settings">
        <template v-if="settings.active == 'settings'">
          <div
            v-for="(sett, ind) in setting"
            class="setting_"
            :key="ind"
            @click="sett.value = !sett.value"
          >
            <div class="toggler" :class="[sett.value ? 'bg' : '']">
              <div class="slider" :class="[sett.value ? 'btns' : '']"></div>
            </div>
            <span>
              {{ sett.text }}
            </span>
          </div>
          <h5 class="sign-in">
            Sign-In to Account
          </h5>
        </template>

        <div v-if="settings.active == 'set-up'">
          <slot name="setup">
            <h3 class="set-up">
              Nothing <br />
              To Set-Up
            </h3>
          </slot>
        </div>
        <div v-if="settings.active == 'connect'">
          <slot name="connect"></slot>
        </div>
      </div>
    </div>
    <div class="splash" v-if="active == 'splash'">
      <h5>{{ title }}</h5>
    </div>
    <slot name="spotlight" v-if="active == 'spotlight'"></slot>
    <modal :id="removeToolsModal">
      <div class="add-tag del-tag">
        <span class="close-icon" @click="$bvModal.hide(removeToolsModal)">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="10.6667"
                  height="10.6667"
                  fill="white"
                  transform="translate(6.6665 6.66675)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h3>Remove Tool</h3>
        <div class="warning-msg">
          <p>
            Are you sure want to remove tool?
          </p>
        </div>
        <div class="d-flex justify-content-between">
          <b-button variant="danger btn-round-fill " @click="removeCard">
            Yes! Remove
          </b-button>
          <b-button class="btn-simple" @click="$bvModal.hide(removeToolsModal)">
            No! back
          </b-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "../../common/modal";
export default {
  props: ["title", "splash", "img"],
  data() {
    return {
      menu: false,
      fullscreen: false,
      share: false,
      active: this.splash ? "splash" : "spotlight",
      removeToolsModal: this.title,
      settings: {
        active: "settings"
      },
      setting: [
        {
          text: "My Crew may access my set-up ",
          value: true
        },
        {
          text: "Display Stats on Splash",
          value: false
        }
      ]
    };
  },
  components: {
    Modal
  },
  methods: {
    showScreen() {
      this.fullscreen = !this.fullscreen;
    },
    showConfirm() {
      this.$bvModal.show(this.removeToolsModal);
    },
    removeCard() {
      this.$emit("removeCard", this.title);
      this.menu = false;
      this.$bvModal.hide(this.removeToolsModal);
    },
    unset() {
      this.menu = false;
      this.share = false;
    }
  },
  watch: {
    active() {
      this.menu = false;
    },
    splash() {
      this.active = this.splash ? "splash" : "spotlight";
    }
  }
};
</script>

<style lang="scss" scoped>
.add-tag {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  input {
    margin-top: 48px;
    margin-bottom: 30px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-tag {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}
.card-dash {
  background: #ffffff;
  box-shadow: 6px 6px 20px rgba(20, 36, 74, 0.05);
  border-radius: 20px;
  padding: 16px;
  min-height: 300px;

  position: relative;
  .title {
    margin-top: -21px;
    margin-right: 28px;
    margin-bottom: 23px;
    text-align: center;
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    line-height: 22px;
    color: #474d52;
    text-transform: uppercase;
  }
  .ico__menu {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
  .share {
    position: absolute;
    top: 26px;
    right: 52px;
    background-color: #fff;
    z-index: 3;
    box-shadow: 0px 4px 8px rgba(111, 111, 111, 0.1);
    border-radius: 5px;
    padding: 6px;
    width: 94px;
    padding-bottom: 5px !important;
    display: flex;
    .social_ico {
      padding-left: 4px;
      padding-right: 4px;
    }
  }
  .menu {
    position: absolute;
    top: 26px;
    right: 34px;
    background-color: #fff;
    z-index: 3;
    box-shadow: 0px 4px 8px rgba(111, 111, 111, 0.1);
    border-radius: 5px;
    padding: 15px;
    width: 88px;
    padding-bottom: 5px !important;
    hr {
      margin: 10px 0;
      width: 88px;
      transform: translateX(-15px);
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 18px;
      color: #474d52;
      margin: 3px 0;
      padding: 3px 0;

      cursor: pointer;
      &.active {
        font-weight: bold;
      }
      &.danger {
        color: #ef5c4a;
      }
    }
  }

  .tool-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 0%;
    width: 0%;
    z-index: 2;
    background: white;
    transition: 2s;
    border-radius: 20px;
  }
  .tool-overlay-active {
    height: 100%;
    width: 100%;
    border-radius: 0px;
  }
}
.settings {
  .tabs__settings {
    margin-top: 16px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #ffffff;
    box-shadow: 6px 6px 20px rgba(20, 36, 74, 0.1);
    border-radius: 5px;
    height: 27px;
    span {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      color: #000000;
      cursor: pointer;
      &.active {
        font-weight: 800;
        font-size: 14px;
        line-height: 19px;
        color: #8d97e0;
      }
    }
  }
  .body__settings {
    padding: 10px;
    padding-top: 25px;
    .set-up {
      font-style: normal;
      font-weight: normal;
      font-size: 36px;
      line-height: 49px;
      text-align: center;
      color: #babcca;
    }
  }
}
.splash {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 264px;
  h5 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #babcca;
  }
}
.labels-radial {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.toggler {
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 46.5px;
  height: 24px;
  filter: drop-shadow(3.76471px 3.76471px 18.8235px rgba(22, 27, 69, 0.1));
  background: #fff;
  border-radius: 18px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  &.bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
    &.btns {
      left: 50%;
      background: var(--theme-color);
      box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
    }
  }
}

.setting_ {
  display: grid;
  grid-template-columns: 50px 1fr;
  margin-bottom: 14px;
  span {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;

    color: #171e4e;
  }
}
.sign-in {
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 18px;
  color: #171e4e;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}
.drag-btn {
  cursor: move;
  max-width: 16px;
  .ico__img {
    position: absolute;
    top: 16px;
    width: 18px;
    height: 18px;
  }
}
</style>
